/*
 * Malezia native Build-Your-Own-Bundle builder.
 *
 * Theme-native replacement for Rebuy Bundle Builder widget 291601 on
 * /pages/build-your-bundle. Renders the same four-step builder (step grids,
 * "My Bundle" panel with progress bar, tier pricing, free-gift picker,
 * subscribe / one-time boxes, quick-view modal) from two JSON script tags the
 * theme writes server-side:
 *
 *   #malezia-byob-rules    steps, copy, tiers, gift pool, cart property contract
 *                          (generated from apps/malezia-merchandising rules)
 *   #malezia-byob-catalog  products / variants / selling plans from Liquid
 *
 * Markup and class names mirror Rebuy's builder 1:1 under the byob-* namespace
 * so malezia-byob.css (Rebuy's cascade, renamed) applies unchanged. Font Awesome
 * glyphs are inline SVG. No network call is made until "Add Bundle To Cart",
 * which POSTs /cart/add.js with the `_malezia_*` line properties the
 * bundle-discount Function reads; the Malezia cart drawer (malezia-merch.js)
 * refreshes itself from that request.
 *
 * Pricing shown is what the Function will charge: the tier percentage is
 * applied per line and the discount floored to the cent (see
 * extensions/bundle-discount/test/harness.ts), so the panel total equals the
 * cart total to the cent.
 */
(function () {
  'use strict';

  var root = document.getElementById('malezia-byob');
  if (!root || root.dataset.byobReady) return;
  root.dataset.byobReady = '1';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var RULES = readJson('malezia-byob-rules');
  var CATALOG = readJson('malezia-byob-catalog') || {};
  if (!RULES || !RULES.bundle) return;

  var BUNDLE = RULES.bundle;
  var LABELS = RULES.labels;
  var CART = RULES.cart;
  var MONEY_FORMAT = root.dataset.moneyFormat || '${{amount}}';
  var STORAGE_KEY = RULES.storageKey || 'malezia_byob_v1';
  var ROOT_ID = 'malezia-byob';
  var OPTION_PAD = '                                                    '; // Rebuy's <option> whitespace (affects select width)

  /* ---- Icons (Font Awesome 5 Pro shapes Rebuy used, as inline SVG) ------- */
  var ICONS = {
    'chevron-up': ['0 0 448 512', 'M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z'],
    'chevron-down': ['0 0 448 512', 'M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z'],
    'plus': ['0 0 384 512', 'M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z'],
    'minus': ['0 0 384 512', 'M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z'],
    'check': ['0 0 512 512', 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204 0z'],
    'times': ['0 0 320 512', 'M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z']
  };
  function icon(name, extraClass) {
    var def = ICONS[name];
    var fa = name === 'times' ? 'fal fa-times' : name === 'plus' || name === 'minus' ? 'far fa-' + name : 'fas fa-' + name;
    return '<i aria-hidden="true" class="byob-icon ' + fa + (extraClass ? ' ' + extraClass : '') + '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + def[0] + '" focusable="false"><path fill="currentColor" d="' + def[1] + '"/></svg></i>';
  }

  /* ---- Utilities ---------------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Rebuy's Vue templates leave a single space between sibling elements; inline layout depends on it.
  function vueSpace(html) {
    return html.replace(/(<\/[a-z0-9]+>)(<[a-z])/g, '$1 $2').replace(/(<input [^>]*>)(<span)/g, '$1 $2');
  }
  function tpl(s, vars) {
    return String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] == null ? '' : vars[k]; });
  }
  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    function fixed(n, d) {
      var s = n.toFixed(d);
      return s;
    }
    function withDelims(n, d, thousands, decimal) {
      var parts = fixed(n, d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var out = MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
    // Liquid money_format may include HTML (e.g. <span class=money>); Rebuy showed plain "$27.50".
    return out.replace(/<[^>]*>/g, '');
  }
  function pct2(n) { return (Math.round(n * 100) / 100).toFixed(2) + '%'; }
  function newSession() {
    return 'byob-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  /* ---- Catalog lookups ---------------------------------------------------- */
  var PRODUCT_BY_HANDLE = {};
  var STEP_BY_HANDLE = {};
  BUNDLE.steps.forEach(function (step) {
    step.products.forEach(function (p) {
      var live = CATALOG[p.handle];
      if (!live) return; // product not on this storefront (unpublished): skip the card
      PRODUCT_BY_HANDLE[p.handle] = live;
      STEP_BY_HANDLE[p.handle] = step.id;
    });
  });
  var GIFT_TIER = null;
  BUNDLE.tiers.forEach(function (t) { if (t.gift) GIFT_TIER = t; });
  var GIFT_POOL = GIFT_TIER ? BUNDLE.giftPools[GIFT_TIER.gift.pool] : null;
  var GIFT_ITEMS = GIFT_POOL ? GIFT_POOL.items.slice().sort(function (a, b) { return a.priority - b.priority; })
    .filter(function (i) { return CATALOG[i.handle]; }) : [];

  function product(handle) { return PRODUCT_BY_HANDLE[handle] || CATALOG[handle]; }
  function image(p, size) {
    var img = p.images && p.images[0];
    return img ? img[size] : p.featuredImage;
  }
  function planFor(p, intervalName) {
    var plans = (p.variant && p.variant.sellingPlans) || [];
    for (var i = 0; i < plans.length; i++) if (plans[i].name === intervalName) return plans[i];
    return null;
  }

  /* ---- State -------------------------------------------------------------- */
  var state = {
    items: [],                       // [{handle, qty}] in the order added
    purchase: RULES.purchase.default, // 'one-time' | 'subscription'
    interval: RULES.purchase.subscription.defaultInterval,
    gift: null,                      // chosen gift handle
    lastGift: null,                  // gift handle clicked most recently
    session: newSession(),
    expanded: false,                 // mobile My Bundle sheet
    barVisible: false,               // mobile bundle bar (shown while the builder is in view)
    adding: false,
    added: false
  };

  // Sheet mode (Sep 4 2026, Ferny's phone review): at <= 980px the My Bundle panel is no longer an in-flow card
  // at the bottom of the page (Rebuy's layout, which on a phone meant scrolling to the very end to add the bundle,
  // and a dim overlay with nothing behind it when the 4th item landed). It becomes a full-screen sheet plus a sticky
  // bottom bar, both mounted on <body> — the theme's #PageContainer carries a transform, which would pin
  // position:fixed children to the page instead of the viewport.
  var sheetMedia = window.matchMedia('(max-width: 980px)');
  function isSheet() { return sheetMedia.matches; }
  // Outer div carries .bundle-page (design tokens), inner carries .byob so the page's `.bundle-page .byob …`
  // rules style the sheet exactly like the in-grid panel.
  var portalOuter = document.getElementById('byob-mobile');
  if (!portalOuter) {
    portalOuter = document.createElement('div');
    portalOuter.id = 'byob-mobile';
    portalOuter.className = 'bundle-page';
    portalOuter.innerHTML = '<div class="byob-widget byob"></div>';
    document.body.appendChild(portalOuter);
  }
  var portal = portalOuter.firstElementChild;

  function load() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || saved.rulesVersion !== RULES.rulesVersion) return;
      if (Array.isArray(saved.items)) {
        state.items = saved.items.filter(function (i) { return product(i.handle) && i.qty > 0; })
          .map(function (i) { return { handle: i.handle, qty: Math.min(i.qty, BUNDLE.maxQuantityPerLine) }; });
      }
      if (saved.purchase === 'subscription' || saved.purchase === 'one-time') state.purchase = saved.purchase;
      if (RULES.purchase.subscription.intervals.indexOf(saved.interval) !== -1) state.interval = saved.interval;
      if (typeof saved.gift === 'string' || saved.gift === null) state.gift = saved.gift;
      if (typeof saved.lastGift === 'string' || saved.lastGift === null) state.lastGift = saved.lastGift;
      if (typeof saved.session === 'string' && saved.session) state.session = saved.session;
      // Enforce the bundle cap after a rules change.
      var remaining = BUNDLE.maxItems;
      state.items.forEach(function (i) { i.qty = Math.max(0, Math.min(i.qty, remaining)); remaining -= i.qty; });
      state.items = state.items.filter(function (i) { return i.qty > 0; });
    } catch (e) { /* ignore */ }
  }
  function save() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        rulesVersion: RULES.rulesVersion,
        items: state.items, purchase: state.purchase, interval: state.interval,
        gift: state.gift, lastGift: state.lastGift, session: state.session
      }));
    } catch (e) { /* ignore */ }
  }

  /* ---- Derived pricing ---------------------------------------------------- */
  function count() {
    return state.items.reduce(function (n, i) { return n + i.qty; }, 0);
  }
  function tierFor(n) {
    var tier = null;
    BUNDLE.tiers.forEach(function (t) { if (n >= t.minQuantity && (!tier || t.minQuantity > tier.minQuantity)) tier = t; });
    return tier;
  }
  function itemQty(handle) {
    for (var i = 0; i < state.items.length; i++) if (state.items[i].handle === handle) return state.items[i].qty;
    return 0;
  }
  function inBundle(productId) {
    return state.items.some(function (i) { var p = product(i.handle); return p && String(p.id) === String(productId); });
  }

  // Unit price for a product in a purchase mode (cents).
  function unitPrice(p, mode) {
    if (mode === 'subscription') {
      var plan = planFor(p, state.interval);
      if (plan) return plan.price;
    }
    return p.variant.price;
  }
  // Per-line money exactly as Shopify settles the Function: discount floored to the cent.
  function lineMoney(p, qty, mode, tier) {
    var unit = unitPrice(p, mode);
    var gross = unit * qty;
    var pctv = tier && (mode !== 'subscription' || BUNDLE.subscriptions.tierDiscountApplies) ? tier.percentage : 0;
    var discount = Math.floor(gross * pctv / 100);
    return { unit: unit, gross: gross, discount: discount, net: gross - discount, compare: p.variant.price * qty };
  }
  function totals(mode) {
    var n = count(), tier = tierFor(n);
    var t = { count: n, tier: tier, compare: 0, gross: 0, net: 0, savings: 0 };
    state.items.forEach(function (i) {
      var p = product(i.handle); if (!p) return;
      var m = lineMoney(p, i.qty, mode, tier);
      t.compare += m.compare; t.gross += m.gross; t.net += m.net;
    });
    t.savings = t.compare - t.net;
    return t;
  }
  // Nominal "Save X%" for the subscription box: plan discount stacked with the tier (Rebuy's number).
  function subscriptionSavePct() {
    var one = totals('one-time'), sub = totals('subscription');
    if (!one.compare) return 0;
    var planRatio = sub.gross / one.compare; // 0.9 for a 10% plan
    var tierPct = one.tier ? one.tier.percentage : 0;
    return (1 - planRatio * (1 - tierPct / 100)) * 100;
  }

  /* ---- Gift plan (ported from bundle-builder-premium.js planGifts) -------- */
  function giftPlan() {
    var n = count(), tier = tierFor(n);
    if (!tier || !tier.gift || !GIFT_ITEMS.length) return { state: 'off', entries: [], keep: null };
    var entries = GIFT_ITEMS.map(function (g) {
      return { handle: g.handle, productId: g.productId, variantId: g.variantId,
        hidden: GIFT_POOL.hideIfInBundle && inBundle(g.productId), selected: state.gift === g.handle };
    });
    var visible = entries.filter(function (e) { return !e.hidden; });
    var picked = visible.filter(function (e) { return e.selected; });
    var keep = null;
    if (picked.length) {
      keep = picked.filter(function (e) { return e.handle === state.lastGift; })[0] || picked[0];
    } else if (visible.length === 1 && GIFT_POOL.autoSelectWhenSingle) {
      keep = visible[0];
    }
    entries.forEach(function (e) { e.selected = !!keep && e.handle === keep.handle; });
    return { state: !visible.length ? 'none' : visible.length === 1 ? 'one' : 'pick', entries: entries, keep: keep };
  }
  function reconcileGift() {
    var plan = giftPlan();
    var next = plan.keep ? plan.keep.handle : null;
    if (next !== state.gift) state.gift = next;
    return plan;
  }

  /* ---- Actions ------------------------------------------------------------ */
  function addItem(handle, qty) {
    var p = product(handle); if (!p || !p.variant.available) return false;
    var room = BUNDLE.maxItems - count(); if (room <= 0) return false;
    var existing = null;
    state.items.forEach(function (i) { if (i.handle === handle) existing = i; });
    var add = Math.min(qty || 1, room, BUNDLE.maxQuantityPerLine - (existing ? existing.qty : 0));
    if (add <= 0) return false;
    if (existing) existing.qty += add; else state.items.push({ handle: handle, qty: add });
    afterChange(true);
    return true;
  }
  function decrementItem(handle) {
    state.items.forEach(function (i) { if (i.handle === handle) i.qty -= 1; });
    state.items = state.items.filter(function (i) { return i.qty > 0; });
    afterChange(true);
  }
  function removeItem(handle) {
    state.items = state.items.filter(function (i) { return i.handle !== handle; });
    afterChange(true);
  }
  function chooseGift(handle) {
    state.gift = handle; state.lastGift = handle;
    afterChange(false);
  }
  function removeGift() {
    state.gift = null; state.lastGift = null;
    afterChange(false);
  }
  // Rebuy toggled the My Bundle container whenever the bundle filled up (<1200px). Kept the useful half: when the
  // last slot is taken on a phone, the sheet OPENS (never closes) so the shopper lands on the gift picker + CTA
  // with a "Bundle complete" banner — instead of a blank dimmed screen.
  function setExpanded(on) {
    state.expanded = !!on && isSheet();
    document.body.classList.toggle('byob-modal-visible', state.expanded);
    document.body.classList.toggle('byob-container-visible', state.expanded);
  }
  function afterChange(itemsChanged) {
    var plan = reconcileGift();
    if (plan.state === 'off') { state.gift = null; }
    if (itemsChanged && BUNDLE.maxItems - count() < 1 && isSheet()) setExpanded(true);
    state.added = false;
    save();
    render();
  }

  /* ---- Renderers ---------------------------------------------------------- */
  function moneyHtml(sale, compare, srSale, srCompare, srPlain) {
    if (compare > sale) {
      return '<span class="byob-money sale"><span class="sr-only">' + esc(srSale) + '</span><span>' + formatMoney(sale) + '</span></span>' +
        '<span class="byob-money compare-at"><span class="sr-only">' + esc(srCompare) + '</span><span>' + formatMoney(compare) + '</span></span>';
    }
    return '<span class="byob-money"><span class="sr-only">' + esc(srPlain) + '</span><span>' + formatMoney(sale) + '</span></span>';
  }

  function renderHeader() {
    var h = RULES.header;
    return '<div class="byob__main-header">' +
      '<h1 class="byob__main-header-super-title">' + esc(h.superTitle) + '</h1>' +
      '<h2 class="byob__main-header-title">' + esc(h.title) + '</h2>' +
      '<p class="byob__main-header-description">' + esc(h.description) + '</p>' +
      '</div>' +
      '<div class="byob__header-utility-container byob__header-utility-container--end"></div>';
  }

  function renderCard(p, tier) {
    var qty = itemQty(p.handle);
    var m = lineMoney(p, 1, state.purchase, tier);
    var href = p.url + '?variant=' + p.variant.id;
    var classes = 'byob-product-block ' + esc(p.handle) + ' product-id-' + p.id +
      (p.tags || []).map(function (t) { return ' tag-' + String(t).toLowerCase().replace(/[^a-z0-9]+/g, ''); }).join('');
    var actions;
    if (qty > 0) {
      actions = '<div><div class="byob__item-quantity-widget">' +
        '<button type="button" aria-label="Decrease quantity of ' + esc(p.title) + '" class="byob__item-quantity-widget-button" data-action="dec" data-handle="' + esc(p.handle) + '">' + icon('minus', 'byob-grey') + '</button>' +
        '<span class="byob__item-quantity-widget-label">' + qty + '</span>' +
        '<button type="button" aria-label="Increase quantity of ' + esc(p.title) + '" class="byob__item-quantity-widget-button" data-action="inc" data-handle="' + esc(p.handle) + '">' + icon('plus', 'byob-grey') + '</button>' +
        '</div></div>';
    } else if (!p.variant.available) {
      actions = '<button type="button" class="byob-button" disabled><span>' + esc(LABELS.outOfStock) + '</span></button>';
    } else {
      actions = '<button type="button" aria-label="Add the product, ' + esc(p.title) + ' to Cart" class="byob-button" data-action="add" data-handle="' + esc(p.handle) + '"><span>' + esc(LABELS.addToBundle) + '</span></button>';
    }
    return '<div aria-label="product" role="listitem" class="' + classes + '">' +
      '<div class="byob__step-product">' +
      '<div class="byob-product-media">' +
      '<a href="' + esc(href) + '" rel="nofollow" class="byob-product-image clickable" data-action="quickview" data-handle="' + esc(p.handle) + '">' +
      '<img loading="eager" src="' + esc(image(p, 'w400')) + '" alt="View ' + esc(p.title) + '" class="byob-style__hover-transition">' +
      '</a></div>' +
      '<div class="byob-product-info">' +
      '<h5 class="byob-product-title clickable"><a href="' + esc(href) + '" aria-label="View ' + esc(p.title) + '" rel="nofollow" class="byob-product-title clickable" data-action="quickview" data-handle="' + esc(p.handle) + '">' + esc(p.title) + '</a></h5>' +
      '<div class="byob-product-price"><div>' + moneyHtml(m.net, m.compare, 'Sale price', 'Original price', 'Price') + '</div></div>' +
      '</div>' +
      '<div class="byob__product-actions byob-product-actions">' +
      '<button type="button" class="byob-button secondary byob__product-quick-view" data-action="quickview" data-handle="' + esc(p.handle) + '">' + esc(LABELS.quickView) + '</button>' +
      '<div class="byob__product-quantity">' + actions + '</div>' +
      '</div></div></div>';
  }

  function renderSteps(tier) {
    return '<div role="list" class="byob__steps-container">' + BUNDLE.steps.map(function (step, idx) {
      var btn = idx === 0
        ? '<button type="button" aria-label="scroll to top" class="byob__scroll-to-button byob__top-button byob__step-button-0" data-action="scroll" data-target="top">' + icon('chevron-up') + '<span>' + esc(LABELS.top) + '</span></button>'
        : '<button type="button" aria-label="scroll to previous step" class="byob__scroll-to-button byob__prev-button byob__step-button-' + idx + '" data-action="scroll" data-target="' + (idx - 1) + '">' + icon('chevron-up') + '<span>' + esc(LABELS.prev) + '</span></button>';
      var cards = step.products.map(function (sp) { var p = product(sp.handle); return p ? renderCard(p, tier) : ''; }).join('');
      return '<div aria-label="step" role="listitem" class="byob__step-container byob__step-container-' + idx + ' byob__step-container--active" data-step-index="' + idx + '">' +
        '<div class="byob__step-header">' +
        '<div class="byob__step-header-copy-container">' +
        '<h3 class="byob__step-header-title">' + esc(step.title) + '</h3>' +
        '<p class="byob__step-header-description">' + esc(step.description) + '</p>' +
        '</div>' +
        '<div class="byob__step-header-actions">' + btn + '</div>' +
        '</div>' +
        '<div role="list" class="byob__step-body byob-product-grid start-column byob-product-grid-step-100 large-columns-3 medium-columns-2 small-columns-2 byob-product-grid__step-' + idx + '">' + cards + '</div>' +
        '</div>';
    }).join('') + '</div>';
  }

  function renderProgress(n) {
    var max = BUNDLE.maxItems;
    var pct = Math.round(Math.min(n, max) / max * 100);
    var steps = BUNDLE.tiers.map(function (t, i) {
      var left = Math.round((i + 1) / max * 100) - 4; // Rebuy: 21% / 46% / 71% / 96%
      return '<div class="byob__progress-step' + (n >= t.minQuantity ? ' complete' : '') + ' byob__progress-step--' + i + '" style="left: ' + left + '%;">' +
        '<div class="byob__progress-step-icon byob__progress-step-icon-type-percentage">' +
        '<span class="byob__progress-step-value byob__progress-step-value-type--percentage">' + t.percentage + '%</span>' +
        '</div>' +
        '<span class="byob__progress-step-label">' + esc(tpl(LABELS.progressStep, { count: t.minQuantity })) + '</span>' +
        '</div>';
    }).join('');
    return '<div class="byob__group-container-progress-bar">' +
      '<div class="byob__group-progress-step-wrapper byob__progress-step-wrapper count-' + BUNDLE.tiers.length + '">' + steps + '</div>' +
      '<div class="byob__progress-bar-wrapper">' +
      '<div class="byob__progress-bar-meter ' + (pct > 0 ? 'has-progress' : 'no-progress') + '">' +
      '<div role="progressbar" tabindex="0" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + esc(LABELS.progressAria) + '" class="byob__progress-bar-meter-fill" style="width: ' + pct + '%;">' +
      '<span class="sr-only">' + esc(tpl(LABELS.progressSr, { percent: pct })) + '</span>' +
      '</div></div></div></div>';
  }

  function renderGifts(plan) {
    if (plan.state === 'off') return '';
    var header = RULES.gift[plan.state];
    var cards = plan.entries.map(function (e) {
      var p = product(e.handle); if (!p) return '';
      var st = e.hidden ? 'hidden' : e.selected ? 'selected' : 'available';
      var btn = e.selected
        ? '<button type="button" class="byob__gift-product-button byob__gift-product-button--remove" aria-label="' + esc(tpl(RULES.gift.removeLabel, { title: p.title })) + '" data-action="gift-remove">' + icon('times') + '</button>'
        : '<button type="button" class="byob-button byob__gift-product-button byob__gift-product-button--add" data-action="gift-add" data-handle="' + esc(p.handle) + '"><span>' + esc(RULES.gift.selectLabel) + '</span></button>';
      return '<div class="byob__gift-product"' + (e.hidden ? ' hidden style="display: none;"' : '') + ' data-malezia-gift="' + st + '">' +
        '<div class="byob__gift-product-image"><img src="' + esc(image(p, 'w80')) + '" alt="View ' + esc(p.title) + '"></div>' +
        '<div class="byob__gift-product-info-wrapper">' +
        '<div class="byob__gift-product-info"><h3 class="byob__gift-product-title">' + esc(p.title) + '</h3></div>' +
        '<div class="byob__gift-product-actions">' + (e.selected ? '<span class="byob__gift-product-selected" role="status">' + icon('check') + '<span>' + esc(RULES.gift.selectedLabel || 'Selected') + '</span></span>' : '') + btn + '</div>' +
        '</div></div>';
    }).join('');
    return '<div class="byob__group-container-gifts" data-gift-state="' + plan.state + '">' +
      '<h3 class="byob__gift-header">' + esc(header) + '</h3>' + cards + '</div>';
  }

  function renderHolders(tier) {
    var slots = [];
    state.items.forEach(function (i) { for (var k = 0; k < i.qty; k++) slots.push(i); });
    var out = '';
    for (var s = 0; s < BUNDLE.maxItems; s++) {
      var i = slots[s];
      if (i) {
        var p = product(i.handle);
        var m = lineMoney(p, 1, state.purchase, tier);
        out += '<div aria-label="' + esc(p.title) + '" role="listitem" class="byob__product-holder">' +
          '<div class="byob__product-holder-data">' +
          '<div class="byob__product-holder-info--left">' +
          '<div class="byob__product-holder-media byob-product-media"><img src="' + esc(image(p, 'w160')) + '" alt="View ' + esc(p.title) + '"></div>' +
          '<div class="byob__product-holder-info byob-product-info">' +
          '<h3 class="byob__product-holder-info-title byob-product-title">' + esc(p.title) + '</h3>' +
          '<div class="byob__product-holder-info-price byob-product-price"><div>' + moneyHtml(m.net, m.compare, 'Sale price', 'Original price', 'Price') + '</div></div>' +
          '</div></div>' +
          '<div class="byob__product-holder-info--right">' +
          '<button type="button" aria-label="Remove ' + esc(p.title) + ' from bundle" class="byob__product-holder-info-delete" data-action="holder-remove" data-handle="' + esc(p.handle) + '">' + icon('times') + '</button>' +
          '</div></div></div>';
      } else {
        out += '<div aria-label="Bundle product" role="listitem" class="byob__product-holder">' +
          '<div class="byob__product-holder-template">' +
          '<div class="byob__product-sign-holder"><span class="byob__product-holder-icon">' + icon('plus') + '</span></div>' +
          '<div class="byob__product-holder-detail">' +
          '<h3 class="byob__product-holder-detail-title">' + esc(RULES.holders.title) + '</h3>' +
          '<p class="byob__product-holder-detail-description">' + esc(RULES.holders.descriptions[s] || '') + '</p>' +
          '</div></div></div>';
      }
    }
    return '<div role="list" aria-label="Selected bundle products" class="byob__group-container-body-items">' + out + '</div>';
  }

  function renderActionBoxes(n) {
    var sub = RULES.purchase.subscription, one = RULES.purchase.oneTime;
    var tOne = totals('one-time'), tSub = totals('subscription');
    var empty = n === 0;
    function price(t) {
      if (empty) return '';
      return '<span>' +
        '<span class="byob-money compare-at"><span class="sr-only">Original subtotal price</span><span>' + formatMoney(t.compare) + '</span></span>' +
        '<span class="byob-money sale"><span class="sr-only">Sale subtotal price</span><span>' + formatMoney(t.net) + '</span></span>' +
        '</span>';
    }
    var details = empty ? '' :
      '<div class="byob__action-box-details">' +
      '<select id="byob-subscription-interval" aria-label="' + esc(sub.intervalAriaLabel) + '" class="byob-select byob__action-box-select" data-action="interval">' +
      sub.intervals.map(function (name) { return '<option value="' + esc(name) + '"' + (name === state.interval ? ' selected' : '') + '>\n' + OPTION_PAD + esc(name) + '\n' + OPTION_PAD.slice(4) + '</option>'; }).join('') +
      '</select>' +
      '<span class="byob__action-box-saving"><span>' + esc(sub.saveLabel) + '</span><span>' + pct2(subscriptionSavePct()) + '</span></span>' +
      '</div>';
    return '<div class="byob__subscription-options">' +
      '<div class="byob__action-box-cta byob__action-box-subscription' + (empty ? ' byob__action-box-cta--disabled' : '') + '">' +
      '<div class="byob__action-box-top">' +
      '<label class="byob-radio-label"><input value="subscription" type="radio" name="byob-purchase"' + (empty ? ' disabled' : '') + (state.purchase === 'subscription' ? ' checked' : '') + ' class="radio-input byob-radio byob__action-box-radio" data-action="purchase">' +
      '<span class="byob__action-box-label">' + esc(sub.label) + '</span></label>' +
      '<div class="byob__action-box-price">' + price(tSub) + '</div>' +
      '</div>' +
      '<div class="byob__action-box-bottom"><p class="byob__action-box-description">' + esc(sub.description) + '</p>' + details + '</div>' +
      '</div>' +
      '<div class="byob__action-box-cta byob__action-box-subscription">' +
      '<div class="byob__action-box-top">' +
      '<label class="byob-radio-label"><input value="one-time" type="radio" name="byob-purchase"' + (state.purchase === 'one-time' ? ' checked' : '') + ' class="radio-input byob-radio byob__action-box-radio" data-action="purchase">' +
      '<span class="byob__action-box-label">' + esc(one.label) + '</span></label>' +
      '<div class="byob__action-box-price">' + price(tOne) + '</div>' +
      '</div>' +
      '<div class="byob__action-box-bottom"><p class="byob__action-box-description">' + esc(one.description) + '</p></div>' +
      '</div></div>';
  }

  function renderGroup(plan) {
    var n = count(), tier = tierFor(n);
    var t = totals(state.purchase);
    var expanded = state.expanded;
    var savings = t.savings > 0
      ? '<div class="byob__total-savings-container"><span class="byob__total-savings-label">' + esc(LABELS.totalSavings) + '</span>' +
        '<span class="byob__total-savings-amount byob-money sale">' + formatMoney(t.savings) + '</span></div>'
      : '';
    var ctaLabel = state.adding ? LABELS.adding : state.added ? LABELS.added : LABELS.addBundle;
    return '<div class="byob__group-container ' + (expanded ? 'expanded' : 'default') + '">' +
      '<div class="byob__group-container-inner">' +
      '<div class="byob__group-container-header">' +
      '<div class="byob__group-container-header--left">' +
      '<h3 class="byob__group-container-header-title">' + esc(LABELS.myBundle) + '</h3>' +
      '<span class="byob__group-container-header-title-count">' +
      '<span class="byob__group-container-header-products_count">' + n + '</span>' +
      '<span class="byob__group-container-header-divider">/</span>' +
      '<span class="byob__group-container-header-container-length">' + BUNDLE.maxItems + '</span>' +
      '</span></div>' +
      '<button type="button" aria-label="' + esc(expanded ? LABELS.collapse : LABELS.expand) + '" class="byob__group-container-header-expand"' + (expanded ? ' aria-expanded="true"' : '') + ' data-action="toggle">' +
      icon(expanded ? 'chevron-down' : 'chevron-up') + '</button>' +
      // Sheet-only (hidden >= 981px): an explicit close, since the sheet covers the page.
      '<button type="button" class="byob__sheet-close" aria-label="' + esc(LABELS.collapse) + '" data-action="toggle">' + icon('times') + '<span>' + esc(LABELS.sheetClose || 'Close') + '</span></button>' +
      '</div>' +
      (n >= BUNDLE.maxItems && tier ? '<div class="byob__sheet-banner" role="status">' + icon('check') + '<span>' + esc(tpl(LABELS.sheetComplete || 'Bundle complete — {{percent}}% off unlocked', { percent: tier.percentage })) + '</span></div>' : '') +
      renderProgress(n) +
      renderGifts(plan) +
      '<div class="byob__group-container-body ' + (expanded ? 'expanded' : 'default') + '">' +
      renderHolders(tier) +
      savings +
      renderActionBoxes(n) +
      '</div>' +
      '<div class="byob__group-container-action"><div class="byob__cta-container">' +
      '<button type="button" aria-label="Add all selected products to cart" class="byob-button' + (state.adding ? ' is-loading' : '') + '"' + (n === 0 || state.adding ? ' disabled' : '') + ' data-action="add-to-cart"><span>' + esc(ctaLabel) + '</span></button>' +
      '</div></div>' +
      '</div></div>';
  }

  // Sticky bottom bar (sheet mode only): count, running total, what the next item unlocks, and the CTA —
  // so nothing about the bundle is ever more than a glance or one tap away while scrolling the steps.
  function renderBar(plan) {
    var n = count(), tier = tierFor(n), max = BUNDLE.maxItems;
    var t = totals(state.purchase);
    var next = null;
    BUNDLE.tiers.forEach(function (x) { if (x.minQuantity > n && (!next || x.minQuantity < next.minQuantity)) next = x; });
    var B = RULES.bar || {};
    var hint;
    if (n === 0) hint = B.empty || 'Pick a product to start saving';
    else if (next) hint = tpl(B.next || 'Add {{count}} more for {{percent}}% off{{gift}}', { count: next.minQuantity - n, percent: next.percentage, gift: next.gift ? (B.nextGift || ' + a gift 🎁') : '' });
    else if (plan.state === 'pick' && !plan.keep) hint = tpl(B.pickGift || '{{percent}}% off unlocked · Pick your gift 🎁', { percent: tier.percentage });
    else if (plan.keep) hint = tpl(B.withGift || '{{percent}}% off + your gift 🎁', { percent: tier.percentage });
    else hint = tpl(B.complete || '{{percent}}% off unlocked', { percent: tier.percentage });
    var pct = Math.round(Math.min(n, max) / max * 100);
    var ctaLabel = state.adding ? LABELS.adding : state.added ? LABELS.added : (B.cta || LABELS.addBundle);
    return '<div class="byob__bar' + (state.barVisible ? ' is-visible' : '') + '" role="region" aria-label="' + esc(LABELS.myBundle) + '">' +
      '<div class="byob__bar-meter" aria-hidden="true"><span style="width: ' + pct + '%;"></span></div>' +
      '<button type="button" class="byob__bar-summary" data-action="toggle" aria-expanded="false" aria-label="' + esc(LABELS.expand) + '">' +
      '<span class="byob__bar-row"><span class="byob__bar-title">' + esc(LABELS.myBundle) + ' <b>' + n + '/' + max + '</b></span>' +
      (n ? '<span class="byob__bar-price"><span class="byob-money' + (t.compare > t.net ? ' sale' : '') + '">' + formatMoney(t.net) + '</span>' + (t.compare > t.net ? ' <s class="byob-money compare-at">' + formatMoney(t.compare) + '</s>' : '') + '</span>' : '') +
      '</span>' +
      '<span class="byob__bar-hint"><span class="byob__bar-hint-text">' + esc(hint) + '</span> <span class="byob__bar-view">' + esc(B.view || 'View bundle ›') + '</span></span>' +
      '</button>' +
      '<button type="button" aria-label="Add all selected products to cart" class="byob-button byob__bar-cta' + (state.adding ? ' is-loading' : '') + '"' + (n === 0 || state.adding ? ' disabled' : '') + ' data-action="add-to-cart"><span>' + esc(ctaLabel) + '</span></button>' +
      '</div>';
  }
  function barShouldShow() {
    var r = root.getBoundingClientRect();
    // Visible from the moment the first step scrolls into view until the builder scrolls out at the top
    // (the "Made around you" band takes over from there).
    return r.top < window.innerHeight - 160 && r.bottom > 120;
  }
  var barTick = false;
  function updateBar() {
    if (barTick) return;
    barTick = true;
    window.requestAnimationFrame(function () {
      barTick = false;
      var show = isSheet() && barShouldShow();
      if (show !== state.barVisible) {
        state.barVisible = show;
        var bar = portal.querySelector('.byob__bar');
        if (bar) bar.classList.toggle('is-visible', show);
      }
      // Shopify's theme-preview bar (#PBarNextFrameWrapper, older #preview-bar-iframe) is fixed to the
      // bottom edge on unpublished themes; sit above it so it never covers the CTA. 0 once published.
      var offset = 0;
      ['PBarNextFrameWrapper', 'preview-bar-iframe'].forEach(function (id) {
        var pb = document.getElementById(id);
        if (!pb) return;
        var r = pb.getBoundingClientRect();
        if (r.height && r.bottom >= window.innerHeight - 1 && r.top > window.innerHeight / 2) offset = Math.max(offset, window.innerHeight - r.top);
      });
      portalOuter.style.setProperty('--byob-bar-offset', Math.round(offset) + 'px');
    });
  }
  window.addEventListener('scroll', updateBar, { passive: true });
  window.addEventListener('resize', updateBar);
  sheetMedia.addEventListener ? sheetMedia.addEventListener('change', function () { setExpanded(false); render(); })
    : sheetMedia.addListener(function () { setExpanded(false); render(); });

  function render() {
    var plan = giftPlan();
    var tier = tierFor(count());
    var scrollY = window.scrollY;
    var sheet = isSheet();
    var groupHtml = renderGroup(plan);
    var openSheet = sheet ? portal.querySelector('.byob__group-container.expanded') : null;
    var sheetScroll = openSheet ? openSheet.scrollTop : 0;
    root.innerHTML = vueSpace('<div class="byob__main byob-layout byob__layout--side_by_side">' +
      renderHeader() +
      '<div class="byob__main-body">' + renderSteps(tier) + (sheet ? '' : groupHtml) + '</div>' +
      '</div>');
    state.barVisible = sheet && barShouldShow();
    portal.innerHTML = sheet ? vueSpace(renderBar(plan) +
      // Backdrop behind the open sheet; tapping it closes the sheet (the sheet itself covers the viewport, so this
      // only shows through during the open/close transition and on very wide phones).
      (state.expanded ? '<div class="byob__full-screen-background byob-full-screen__background" data-action="toggle"></div>' : '') +
      groupHtml) : '';
    if (sheet && state.expanded) {
      var s = portal.querySelector('.byob__group-container.expanded');
      if (s && sheetScroll) s.scrollTop = sheetScroll;
    }
    updateBar();
    if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    root.dispatchEvent(new CustomEvent('byob:render', { bubbles: true, detail: { count: count(), purchase: state.purchase } }));
  }

  /* ---- Quick view modal --------------------------------------------------- */
  var modal = null;
  var modalState = { handle: null, qty: 1, image: 0 };
  function openModal(handle) {
    var p = product(handle); if (!p) return;
    modalState = { handle: handle, qty: 1, image: 0 };
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'byob-modal';
      modal.className = 'byob-modal';
      document.body.appendChild(modal);
      modal.addEventListener('click', onModalClick);
    }
    renderModal();
    modal.classList.add('is-visible');
    document.body.classList.add('byob-modal-visible');
    // Move focus into the dialog (keyboard/screen-reader users); the container carries no focus ring, so the
    // visual is identical to Rebuy's, which leaves focus where it was.
    var dialog = modal.querySelector('.byob-modal__container'); if (dialog && dialog.focus) dialog.focus({ preventScroll: true });
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-visible');
    document.body.classList.remove('byob-modal-visible');
    modal.innerHTML = '';
  }
  function renderModal() {
    var p = product(modalState.handle); if (!p || !modal) return;
    var tier = tierFor(count());
    var m = lineMoney(p, 1, state.purchase, tier);
    var imgs = p.images && p.images.length ? p.images : [{ w400: p.featuredImage, w200: p.featuredImage, alt: p.title }];
    var main = imgs[Math.min(modalState.image, imgs.length - 1)];
    var subs = imgs.length > 1 ? '<div class="byob-modal__product-sub-images">' + imgs.map(function (im, i) {
      return '<div role="button" tabindex="0" class="byob-modal__product-sub-image' + (i === modalState.image ? ' is-active' : '') + '" data-action="modal-image" data-index="' + i + '"><img src="' + esc(im.w200) + '" alt="' + esc(p.title) + '"></div>';
    }).join('') + '</div>' : '';
    modal.innerHTML = vueSpace('<div class="byob-modal__container dialog is-visible" role="dialog" aria-modal="true" tabindex="-1" aria-label="' + esc(LABELS.modalTitle) + '">' +
      '<button type="button" aria-label="Close modal" class="byob-modal__close" data-action="modal-close">' + icon('times') + '</button>' +
      '<div class="byob-modal__container-header">' + esc(LABELS.modalTitle) + '</div>' +
      '<div class="byob-modal__container-body">' +
      '<div class="byob-modal__product byob-modal__product--layout-grid large-style-line medium-style-line small-style-line">' +
      '<div class="byob-modal__product-media">' +
      '<img src="' + esc(main.w400) + '" alt="' + esc(p.title) + '" class="byob-modal__product-media-image">' + subs +
      '</div>' +
      '<div class="byob-modal__product-info">' +
      '<h4 class="byob-modal__product-title">' + esc(p.title) + '</h4>' +
      // Rebuy's quick view shows the plain variant price (no tier maths) — mirrored.
      '<div class="byob-modal__product-price"><div><span class="byob-money">' + formatMoney(p.variant.price) + '</span></div></div>' +
      '<div class="byob-modal__product-stock ' + (p.variant.available ? 'in-stock' : 'out-of-stock') + '"><span class="byob-modal__product-stock-indicator"></span><span class="byob-modal__product-stock-label">' + esc(p.variant.available ? LABELS.inStock : LABELS.outOfStock) + '</span></div>' +
      '<div><div class="byob-modal__product-quantity-controller">' +
      '<button type="button" aria-label="Decrease quantity of ' + esc(p.title) + '" class="byob-modal__product-quantity-controller-button" data-action="modal-dec">' + icon('minus', 'byob-grey') + '</button>' +
      '<span class="byob-modal__product-quantity-controller-label">' + modalState.qty + '</span>' +
      '<button type="button" aria-label="Increase quantity of ' + esc(p.title) + '" class="byob-modal__product-quantity-controller-button" data-action="modal-inc">' + icon('plus', 'byob-grey') + '</button>' +
      '</div></div>' +
      '<div class="byob-modal__product-options"></div>' +
      '</div></div></div>' +
      '<div class="byob-modal__container-actions multi-button">' +
      '<button type="button" class="byob-button primary block" data-action="modal-add">' + esc(LABELS.modalAdd) + '</button>' +
      '<button type="button" class="byob-button outline" data-action="modal-close">' + esc(LABELS.modalDismiss) + '</button>' +
      '</div></div>');
  }
  function onModalClick(e) {
    var t = e.target.closest('[data-action]');
    if (!t) { if (e.target === modal) closeModal(); return; }
    var room = BUNDLE.maxItems - count();
    switch (t.dataset.action) {
      case 'modal-close': closeModal(); break;
      case 'modal-dec': modalState.qty = Math.max(1, modalState.qty - 1); renderModal(); break;
      case 'modal-inc': modalState.qty = Math.min(modalState.qty + 1, Math.max(1, Math.min(room, BUNDLE.maxQuantityPerLine))); renderModal(); break;
      case 'modal-image': modalState.image = Number(t.dataset.index) || 0; renderModal(); break;
      case 'modal-add': addItem(modalState.handle, modalState.qty); closeModal(); break;
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-visible')) closeModal();
  });

  /* ---- Add to cart -------------------------------------------------------- */
  function cartItems() {
    var plan = giftPlan();
    var base = {};
    base[CART.source.key] = CART.source.value;
    base[CART.bundleIdKey] = BUNDLE.id;
    base[CART.sessionKey] = state.session;
    base[CART.rulesVersionKey] = RULES.rulesVersion;
    var items = state.items.map(function (i) {
      var p = product(i.handle);
      var props = Object.assign({}, base);
      props[CART.stepKey] = STEP_BY_HANDLE[i.handle] || '';
      var line = { id: p.variant.id, quantity: i.qty, properties: props };
      if (state.purchase === 'subscription') {
        var sp = planFor(p, state.interval);
        if (sp) line.selling_plan = sp.id;
      }
      return line;
    });
    if (plan.keep) {
      var g = product(plan.keep.handle);
      var gprops = Object.assign({}, base);
      gprops[CART.giftKey] = 'true';
      gprops[CART.giftPoolKey] = GIFT_TIER.gift.pool;
      // Never a selling plan on the gift line (Function rule + rules.subscriptions.giftMayCarrySellingPlan=false).
      items.push({ id: Number(plan.keep.variantId) || g.variant.id, quantity: GIFT_TIER.gift.quantity || 1, properties: gprops });
    }
    return items;
  }
  function addBundleToCart() {
    if (state.adding || count() === 0) return;
    state.adding = true; state.added = false;
    render();
    var payload = { items: cartItems() };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j && (j.description || j.message) || 'Cart error'); });
      return r.json();
    }).then(function (res) {
      state.adding = false; state.added = true;
      // The bundle is in the cart now: start a fresh bundle/session so a second click cannot double-add.
      state.items = []; state.gift = null; state.lastGift = null; state.session = newSession(); setExpanded(false);
      save();
      render();
      root.dispatchEvent(new CustomEvent('byob:added', { bubbles: true, detail: { response: res, items: payload.items } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { state.added = false; render(); }, 2500);
    }).catch(function (err) {
      state.adding = false; state.added = false;
      render();
      [root, portal].forEach(function (host) {
        host.querySelectorAll('[data-action="add-to-cart"]').forEach(function (btn) {
          btn.setAttribute('data-error', err.message || 'error'); btn.title = err.message || '';
        });
      });
      if (window.console) console.warn('[malezia-byob] add to cart failed:', err);
    });
  }

  /* ---- Events ------------------------------------------------------------- */
  function onClick(e) {
    var t = e.target.closest('[data-action]');
    if (!t || !(root.contains(t) || portal.contains(t))) return;
    var handle = t.dataset.handle;
    switch (t.dataset.action) {
      case 'add': addItem(handle, 1); break;
      case 'inc': addItem(handle, 1); break;
      case 'dec': decrementItem(handle); break;
      case 'holder-remove': removeItem(handle); break;
      case 'gift-add': chooseGift(handle); break;
      case 'gift-remove': removeGift(); break;
      case 'quickview': e.preventDefault(); openModal(handle); break;
      case 'toggle': setExpanded(!state.expanded); render(); break;
      case 'add-to-cart': addBundleToCart(); break;
      case 'scroll': {
        e.preventDefault();
        var target = t.dataset.target === 'top' ? root : root.querySelector('.byob__step-container-' + t.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      }
    }
  }
  function onChange(e) {
    var t = e.target;
    if (t.dataset.action === 'purchase' && t.checked) {
      state.purchase = t.value === 'subscription' ? 'subscription' : 'one-time';
      save(); render();
    } else if (t.dataset.action === 'interval') {
      state.interval = t.value;
      save(); render();
    }
  }
  root.addEventListener('click', onClick);
  root.addEventListener('change', onChange);
  portal.addEventListener('click', onClick);
  portal.addEventListener('change', onChange);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.expanded) { setExpanded(false); render(); }
  });

  /* ---- Boot --------------------------------------------------------------- */
  load();
  reconcileGift();
  render();

  // Debug / QA hook (read-only view of state + pricing).
  window.MaleziaByob = {
    getState: function () { return JSON.parse(JSON.stringify(state)); },
    totals: totals,
    cartItems: cartItems,
    giftPlan: giftPlan,
    reset: function () { state.items = []; state.gift = null; state.lastGift = null; state.purchase = RULES.purchase.default; state.interval = RULES.purchase.subscription.defaultInterval; state.session = newSession(); setExpanded(false); save(); render(); }
  };
})();
